import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // withCredentials: true ensures the HttpOnly __ttauth cookie is included
    const withCreds = req.clone({ withCredentials: true });
   
    return next.handle(withCreds).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Session expired or forbidden — redirect to TTAuth login.
          const returnUrl = encodeURIComponent(window.location.href);
          this.redirectTo(`/ttauth/v1/cookie/login-redirect?returnUrl=${returnUrl}`);
        }
        return throwError(() => error);
      })
    );
  }

  protected redirectTo(url: string): void {
    window.location.href = url;
  }
}
